const e = {
  name: "HeartFill",
  dimensions: { width: 24, height: 24 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.4 3C4.88046 3 2 5.82715 2 9.33333C2 12.6798 4.34708 15.5266 6.48154 17.4515C8.65077 19.4078 10.856 20.6398 11.0768 20.7605C11.3692 20.9223 11.6794 21 12 21C12.3206 21 12.6308 20.9223 12.9232 20.7605C13.144 20.6398 15.3492 19.4078 17.5185 17.4515C19.6529 15.5266 22 12.6798 22 9.33333C22 5.82715 19.1195 3 15.6 3C14.2949 3 13.0485 3.38761 12 4.1014C10.9515 3.38761 9.7051 3 8.4 3Z" fill="currentColor"/>
    </g>
    `
};
export {
  e as HeartFill
};
